export default "<div class=\"snackbar {{type}}\">\n    {{message}}\n</div>\n"